"use client"
import { useState } from "react"
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
} from "@mui/material"
import { LocalHospital } from "@mui/icons-material"
import { sampleData } from "../data/sampleData"

const userTypes = [
  { value: "admin", label: "Administrator" },
  { value: "doctor", label: "Doctor" },
  { value: "staff", label: "Staff" },
  { value: "reception", label: "Front Desk/Reception" },
  { value: "pharmacy", label: "Pharmacy" },
  { value: "lab", label: "Lab Technician" },
  { value: "billing", label: "Account/Billing" },
  { value: "patient", label: "Patient" },
]

export default function LoginPage({ onLogin }) {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
    userType: "",
  })
  const [error, setError] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!credentials.username || !credentials.password || !credentials.userType) {
      setError("Please fill in all fields")
      return
    }

    // Find user in sample data
    const user = sampleData.users.find(
      (u) =>
        u.username === credentials.username &&
        u.password === credentials.password &&
        u.userType === credentials.userType,
    )

    if (user) {
      onLogin(user)
    } else {
      setError("Invalid credentials or user type mismatch")
    }
  }

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3 }}>
            <LocalHospital sx={{ fontSize: 40, color: "primary.main", mr: 1 }} />
            <Typography component="h1" variant="h4" color="primary">
              HMS Login
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Username"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Password"
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
            />
            <FormControl fullWidth margin="normal" required>
              <InputLabel>User Type</InputLabel>
              <Select
                value={credentials.userType}
                label="User Type"
                onChange={(e) => setCredentials({ ...credentials, userType: e.target.value })}
              >
                {userTypes.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Sign In
            </Button>
          </Box>
          <Box sx={{ mt: 2, p: 2, bgcolor: "grey.100", borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Demo Credentials:
            </Typography>
            <Typography variant="caption" display="block">
              Admin: admin / admin123
            </Typography>
            <Typography variant="caption" display="block">
              Doctor: doctor1 / doc123
            </Typography>
            <Typography variant="caption" display="block">
              Reception: reception1 / rec123
            </Typography>
            <Typography variant="caption" display="block">
              Pharmacy: pharmacy1 / pharm123
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  )
}
